import {createSlice} from '@reduxjs/toolkit';

const filterValues = createSlice({
  name: 'filterValues',
  initialState: {
    locationListFilter: {},
    mapFilter: {},
    userListFilter: {},
  },
  reducers: {
    setLocationListFilter: (state, action) => {
      state.locationListFilter = action.payload;
    },
    setMapFilter: (state, action) => {
      state.mapFilter = action.payload;
    },
    setUserListFilter: (state, action) => {
      state.userListFilter = action.payload;
    }
  }
});

export const {setLocationListFilter, setMapFilter, setUserListFilter} = filterValues.actions;

export default filterValues.reducer;
